//import { sendAnalyticsEvent, TraceEvent } from '@uniswap/analytics'
//import { BrowserEvent, InterfaceElementName, InterfaceEventName, SharedEventName } from '@uniswap/analytics-events'
//import { CurrencyAmount, Token } from '@uniswap/sdk-core'
import { BigNumber } from '@ethersproject/bignumber'
import { Zero } from '@ethersproject/constants'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { ButtonEmphasis, ButtonSize, LoadingButtonSpinner, ThemeButton } from 'components/Button'
import Column from 'components/Column'
import { LoadingBubble } from 'components/Tokens/loading'
import { useGetConnection } from 'connection'
import useENSName from 'hooks/useENSName'
import { useUSDPrice } from 'hooks/useUSDPrice'
//import { usePortfolioBalancesQuery } from 'graphql/data/__generated__/types-and-hooks'
//import { useAtomValue } from 'jotai/utils'
import { useProfilePageState, useSellAsset, useWalletCollections } from 'nft/hooks'
import { useIsNftClaimAvailable } from 'nft/hooks/useIsNftClaimAvailable'
//import { ProfilePageStateType } from 'nft/types'
import { useCallback, useEffect, useState } from 'react'
import {
  AlertCircle,
  ArrowDownRight,
  ArrowUpRight,
  CheckCircle,
  Copy,
  IconProps,
  Info,
  Power,
  Settings,
  X,
} from 'react-feather'
import { useNavigate } from 'react-router-dom'
import store from 'state'
//import { shouldDisableNFTRoutesAtom } from 'state/application/atoms'
import { useNativeCurrencyBalances } from 'state/connection/hooks'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { addTransaction, clearAllTransactions } from 'state/transactions/reducer'
import { clearUiPending } from 'state/transactions/reducer'
import { TransactionType } from 'state/transactions/types'
import { updateSelectedWallet } from 'state/user/reducer'
import styled, { useTheme } from 'styled-components/macro'
import { CopyHelper, ExternalLink, ThemedText } from 'theme'
import { formatCurrencyAmount } from 'utils/formatCurrencyAmount'
import { ExplorerDataType, getExplorerLink } from 'utils/getExplorerLink'

import { shortenAddress } from '../../nft/utils/address'
import { useCloseModal } from '../../state/application/hooks'
import WalletStatusIcon from '../Identicon/StatusIcon'
import { useToggleAccountDrawer } from '.'
import IconButton, { IconHoverText } from './IconButton'
import MiniPortfolio from './MiniPortfolio'
import { portfolioFadeInAnimation } from './MiniPortfolio/PortfolioRow'
//import { Trans } from '@lingui/react'
//import { isPending } from '@reduxjs/toolkit'

const AuthenticatedHeaderWrapper = styled.div`
  padding: 20px 10px 20px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
`

const HeaderButton = styled(ThemeButton)`
  border-color: transparent;
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
  height: 40px;
  margin-top: 8px;
`

const WalletButton = styled(ThemeButton)`
  border-radius: 12px;
  padding-top: 10px;
  margin-top: 4px;
  color: white;
  border: none;
`

const UNIButton = styled(WalletButton)`
  border-radius: 8px;
  padding: 8px 6px;
  margin-top: 4px;
  color: white;
  border: none;
  background: linear-gradient(to right, #9139b0 0%, #4261d6 100%);
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  & > a,
  & > button {
    margin-right: 4px;
  }

  & > button:last-child {
    margin-right: 0px;
    ${IconHoverText}:last-child {
      left: 0px;
    }
  }
`
const FiatOnrampNotAvailableText = styled(ThemedText.Caption)`
  align-items: center;
  color: ${({ theme }) => theme.textSecondary};
  display: flex;
  justify-content: center;
`
const FiatOnrampAvailabilityExternalLink = styled(ExternalLink)`
  align-items: center;
  display: flex;
  height: 14px;
  justify-content: center;
  margin-left: 6px;
  width: 14px;
`

const ActionButton = styled(UNIButton)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StatusWrapper = styled.div`
  display: inline-flex;
  width: 70%;
  padding-right: 4px;
`

const AccountNamesWrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0px;
`

const StyledInfoIcon = styled(Info)`
  height: 12px;
  width: 12px;
  flex: 1 1 auto;
`
const StyledLoadingButtonSpinner = styled(LoadingButtonSpinner)`
  fill: ${({ theme }) => theme.accentAction};
`

const HeaderWrapper = styled.div`
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const CopyText = styled(CopyHelper).attrs({
  InitialIcon: Copy,
  CopiedIcon: Copy,
  gap: 4,
  iconSize: 14,
  iconPosition: 'right',
})``

const FadeInColumn = styled(Column)`
  ${portfolioFadeInAnimation}
`

const PortfolioDrawerContainer = styled(Column)`
  flex: 1;
`

const PendingSection = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const PendingButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
`

const StuckTxButton = styled(ActionButton)`
  width: 100%;
  margin-top: 8px;
  background: linear-gradient(to right, #991b1b 0%, #b90000 100%);

  &:hover {
    background: linear-gradient(to right, #8d0000 0%, #6a0000 100%);
  }

  &:disabled {
    background: ${({ theme }) => theme.backgroundInteractive};
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const StatusMessage = styled.div<{ $type: 'success' | 'error' | 'info' | 'loading' }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 12px;
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  background: ${({ theme, $type }) =>
    $type === 'success'
      ? 'rgba(39, 174, 96, 0.1)'
      : $type === 'error'
      ? 'rgba(255, 67, 87, 0.1)'
      : $type === 'loading'
      ? 'rgba(45, 96, 255, 0.1)'
      : theme.backgroundInteractive};
  color: ${({ theme, $type }) =>
    $type === 'success'
      ? theme.accentSuccess
      : $type === 'error'
      ? theme.accentCritical
      : $type === 'loading'
      ? theme.accentAction
      : theme.textPrimary};
  border: 1px solid
    ${({ theme, $type }) =>
      $type === 'success'
        ? theme.accentSuccess
        : $type === 'error'
        ? theme.accentCritical
        : $type === 'loading'
        ? theme.accentAction
        : theme.backgroundOutline};
`

const StatusIconWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 1px;
`

const StatusContent = styled.div`
  flex: 1;
`

const StatusTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`

const StatusDetails = styled.div`
  opacity: 0.8;
  font-size: 12px;
  word-break: break-all;
`

const TxLink = styled.a`
  color: inherit;
  text-decoration: underline;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`

const replacementsKey = (account: string) => `piteas:tx_replacements:v1:${account.toLowerCase()}`
function readReplacements(account?: string): Record<string, string> {
  if (!account) return {}
  try {
    const raw = localStorage.getItem(replacementsKey(account))
    return raw ? (JSON.parse(raw) as Record<string, string>) : {}
  } catch {
    return {}
  }
}
function writeReplacement(account: string | undefined, oldHash: string, newHash: string) {
  if (!account || !oldHash || !newHash) return
  try {
    const map = readReplacements(account)
    map[oldHash.toLowerCase()] = newHash.toLowerCase()
    localStorage.setItem(replacementsKey(account), JSON.stringify(map))
  } catch {
    // Silent fail
  }
}

export function PortfolioArrow({ change, ...rest }: { change: number } & IconProps) {
  const theme = useTheme()
  return change < 0 ? (
    <ArrowDownRight color={theme.accentCritical} size={20} {...rest} />
  ) : (
    <ArrowUpRight color={theme.accentSuccess} size={20} {...rest} />
  )
}

export default function AuthenticatedHeader({ account, openSettings }: { account: string; openSettings: () => void }) {
  const { chainId, connector } = useWeb3React()
  const { ENSName } = useENSName(account)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const closeModal = useCloseModal()
  const setSellPageState = useProfilePageState((state) => state.setProfilePageState)
  const resetSellAssets = useSellAsset((state) => state.reset)
  const clearCollectionFilters = useWalletCollections((state) => state.clearCollectionFilters)
  const isClaimAvailable = useIsNftClaimAvailable((state) => state.isClaimAvailable)

  const userEthBalance = useNativeCurrencyBalances(account ? [account] : [])
  const plsBalance = account && userEthBalance ? userEthBalance[account] : undefined
  const { data: plsUsdPrice } = useUSDPrice(plsBalance)
  const theme = useTheme()

  const [cancelStatus, setCancelStatus] = useState<{
    type: 'success' | 'error' | 'info' | 'loading'
    title: string
    message?: string
    txHash?: string
  } | null>(null)

  useEffect(() => {
    if (cancelStatus?.type === 'success') {
      const timer = setTimeout(() => {
        setCancelStatus(null)
      }, 12000)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [cancelStatus])
  //const shouldDisableNFTRoutes = useAtomValue(shouldDisableNFTRoutesAtom)

  //const unclaimedAmount: CurrencyAmount<Token> | undefined = useUserUnclaimedAmount(account)
  //const isUnclaimed = useUserHasAvailableClaim(account)
  const getConnection = useGetConnection()
  const connection = getConnection(connector)
  //const openClaimModal = useToggleModal(ApplicationModal.ADDRESS_CLAIM)
  //const openNftModal = useToggleModal(ApplicationModal.UNISWAP_NFT_AIRDROP_CLAIM)

  const pendingCount = useAppSelector((state: any) => {
    try {
      const byChain = state?.transactions?.[chainId ?? -1] ?? {}
      const list = Object.values(byChain ?? {}) as any[]
      return list.filter((tx: any) => {
        const fromOk = !tx?.from || String(tx.from).toLowerCase() === String(account).toLowerCase()
        const isPending = !tx?.receipt && !tx?.confirmedTime && tx?.status !== 'failed'
        return fromOk && isPending
      }).length
    } catch {
      return 0
    }
  })

  const disconnect = useCallback(() => {
    if (connector && connector.deactivate) {
      connector.deactivate()
    }
    connector.resetState()
    dispatch(updateSelectedWallet({ wallet: undefined }))
  }, [connector, dispatch])

  const clearAllTransactionsCallback = useCallback(() => {
    if (chainId) dispatch(clearAllTransactions({ chainId }))
  }, [dispatch, chainId])

  const clearUiPendingCallback = useCallback(() => {
    if (chainId) {
      dispatch(clearUiPending({ chainId, account }))
    }
  }, [dispatch, chainId, account])

  const cancelStuckTxCallback = useCallback(async () => {
    setCancelStatus(null)

    try {
      if (!connector || !account || !chainId) {
        setCancelStatus({
          type: 'error',
          title: 'Wallet not connected',
          message: 'Please connect your wallet to continue.',
        })
        return
      }

      setCancelStatus({
        type: 'loading',
        title: 'Preparing cancel transaction...',
        message: 'Fetching stuck transaction details from blockchain.',
      })

      const eth = (await (connector as any)?.getProvider?.()) ?? (window as any).ethereum
      if (!eth) {
        setCancelStatus({
          type: 'error',
          title: 'Provider not available',
          message: 'Unable to connect to wallet provider.',
        })
        return
      }

      const provider = new Web3Provider(eth, 'any')
      const signer = provider.getSigner()

      const allTransactions = store.getState()?.transactions?.[chainId] ?? {}
      const pendingTxs = Object.values(allTransactions).filter((tx: any) => {
        const fromOk = !tx?.from || String(tx.from).toLowerCase() === String(account).toLowerCase()
        const isPending = !tx?.receipt && !tx?.confirmedTime && tx?.status !== 'failed'
        return fromOk && isPending && tx?.hash
      })

      if (!pendingTxs.length) {
        setCancelStatus({
          type: 'info',
          title: 'No pending transactions found',
          message: 'There are no pending transactions to cancel in your wallet.',
        })
        return
      }

      const oldestTx = pendingTxs.sort((a: any, b: any) => {
        if (a?.nonce && b?.nonce) return a.nonce - b.nonce
        return (a?.addedTime ?? 0) - (b?.addedTime ?? 0)
      })[0] as any

      const onChainTx = await provider.getTransaction(oldestTx.hash).catch(() => null)

      if (!onChainTx) {
        setCancelStatus({
          type: 'error',
          title: 'Transaction not found',
          message: 'The transaction may have already been confirmed or dropped from the mempool.',
        })
        return
      }

      setCancelStatus({
        type: 'loading',
        title: 'Sending cancel transaction...',
        message: 'Please confirm in your wallet.',
      })

      const bump = (v?: BigNumber | null) => (v ? v.mul(150).div(100) : undefined)

      const cancelTxReq: any = {
        to: account,
        from: account,
        value: Zero,
        nonce: onChainTx.nonce,
        chainId,
        data: '0x',
        gasLimit: BigNumber.from(21000),
      }

      const currentFee = await provider.getFeeData()

      if (onChainTx.maxFeePerGas && onChainTx.maxPriorityFeePerGas) {
        const maxOriginal = onChainTx.maxFeePerGas.gt(currentFee.maxFeePerGas || 0)
          ? onChainTx.maxFeePerGas
          : currentFee.maxFeePerGas
        const priorityOriginal = onChainTx.maxPriorityFeePerGas.gt(currentFee.maxPriorityFeePerGas || 0)
          ? onChainTx.maxPriorityFeePerGas
          : currentFee.maxPriorityFeePerGas

        cancelTxReq.maxFeePerGas = bump(maxOriginal)
        cancelTxReq.maxPriorityFeePerGas = bump(priorityOriginal)
      } else if (onChainTx.gasPrice || currentFee.gasPrice) {
        const gasPriceToUse =
          onChainTx.gasPrice && onChainTx.gasPrice.gt(currentFee.gasPrice || 0)
            ? onChainTx.gasPrice
            : currentFee.gasPrice
        cancelTxReq.gasPrice = bump(gasPriceToUse)
      }

      const sent = await signer.sendTransaction(cancelTxReq)

      writeReplacement(account, oldestTx.hash, sent.hash)

      dispatch(
        addTransaction({
          hash: sent.hash,
          from: account,
          chainId,
          nonce: onChainTx.nonce,
          info: {
            type: TransactionType.CANCEL,
          },
        })
      )

      setCancelStatus({
        type: 'success',
        title: 'Cancel transaction sent successfully!',
        message: 'The cancel transaction will replace the stuck transaction once it is mined on the blockchain.',
        txHash: sent.hash,
      })
    } catch (err: any) {
      console.error('Cancel stuck tx error:', err)
      setCancelStatus({
        type: 'error',
        title: 'Failed to send cancel transaction',
        message: err?.message || 'An unexpected error occurred.',
      })
    }
  }, [connector, account, chainId, dispatch])

  const toggleWalletDrawer = useToggleAccountDrawer()

  return (
    <AuthenticatedHeaderWrapper>
      <HeaderWrapper>
        <StatusWrapper>
          <WalletStatusIcon connection={connection} size={32} />
          {account && (
            <AccountNamesWrapper>
              <ThemedText.SubHeader>
                <CopyText toCopy={ENSName ?? account}>{ENSName ?? shortenAddress(account, 4, 4)}</CopyText>
              </ThemedText.SubHeader>
              {/* Displays smaller view of account if ENS name was rendered above */}
              {ENSName && (
                <ThemedText.BodySmall color="textTertiary">
                  <CopyText toCopy={account}>{shortenAddress(account, 5, 5)}</CopyText>
                </ThemedText.BodySmall>
              )}
            </AccountNamesWrapper>
          )}
        </StatusWrapper>
        <IconContainer>
          <IconButton data-testid="wallet-settings" onClick={openSettings} Icon={Settings} title="Settings" />
          <IconButton data-testid="wallet-disconnect" onClick={disconnect} Icon={Power} title="Disconnect Wallet" />
          <IconButton onClick={toggleWalletDrawer} Icon={X} title="Close" aria-label="Close" />
        </IconContainer>
      </HeaderWrapper>
      <PortfolioDrawerContainer>
        {account && userEthBalance && userEthBalance[account] ? (
          <FadeInColumn gap="xs">
            <ThemedText.BodySecondary fontSize="14px">Total PLS Balance:</ThemedText.BodySecondary>
            <ThemedText.HeadlineLarge
              fontWeight={700}
              fontSize="28px"
              lineHeight="24px"
              data-testid="portfolio-total-balance"
            >
              {formatCurrencyAmount(userEthBalance[account], 8)} PLS
            </ThemedText.HeadlineLarge>
            {plsUsdPrice && (
              <ThemedText.BodySecondary fontSize="14px" color="textSecondary">
                ≈ ${plsUsdPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </ThemedText.BodySecondary>
            )}
          </FadeInColumn>
        ) : (
          <Column gap="xs">
            <LoadingBubble height="16px" width="100px" margin="4px 0 20px 0" />
            <LoadingBubble height="44px" width="170px" />
          </Column>
        )}
        {account && (
          <PendingSection>
            <ThemedText.BodyPrimary fontWeight={500}>Actions</ThemedText.BodyPrimary>
            <PendingButtons>
              <ActionButton
                onClick={() =>
                  window.open(`https://pulsecoinlist.com/portfolio?address=${account}`, '_blank', 'noopener,noreferrer')
                }
                size={ButtonSize.small}
                emphasis={ButtonEmphasis.medium}
              >
                <div className="flex flex-col items-center">
                  <ThemedText.BodySmall color="#fff">View Portfolio</ThemedText.BodySmall>
                  <ThemedText.Caption color="#fff" opacity="0.6">
                    on Pulsecoinlist
                  </ThemedText.Caption>
                </div>
              </ActionButton>
              <ActionButton
                onClick={clearUiPendingCallback}
                size={ButtonSize.small}
                emphasis={ButtonEmphasis.medium}
                disabled={pendingCount === 0}
                title={pendingCount === 0 ? 'No pending transactions' : `Clear ${pendingCount} pending tx`}
              >
                <div className="flex flex-col items-center">
                  <ThemedText.BodySmall color="#fff">Clear UI pending</ThemedText.BodySmall>
                  <ThemedText.Caption color="#fff" opacity="0.6">
                    {pendingCount === 0
                      ? 'No pending tx'
                      : `Pending transaction${pendingCount > 1 ? 's' : ''}: ${pendingCount}`}
                  </ThemedText.Caption>
                </div>
              </ActionButton>
            </PendingButtons>
            {pendingCount > 0 && (
              <>
                <StuckTxButton
                  onClick={cancelStuckTxCallback}
                  size={ButtonSize.small}
                  emphasis={ButtonEmphasis.medium}
                  disabled={cancelStatus?.type === 'loading'}
                  title="Clear stuck transactions"
                >
                  <div className="flex flex-col items-center">
                    <ThemedText.BodySmall color="#fff">
                      {cancelStatus?.type === 'loading' ? 'Processing...' : 'Clear Stuck Transactions'}
                    </ThemedText.BodySmall>
                    <ThemedText.Caption color="#fff" opacity="0.6">
                      Execute to clear stucked transactions
                    </ThemedText.Caption>
                  </div>
                </StuckTxButton>
                {cancelStatus && (
                  <StatusMessage $type={cancelStatus.type}>
                    <StatusIconWrapper>
                      {cancelStatus.type === 'success' ? (
                        <CheckCircle size={16} />
                      ) : cancelStatus.type === 'error' ? (
                        <AlertCircle size={16} />
                      ) : cancelStatus.type === 'loading' ? (
                        <div style={{ animation: 'spin 1s linear infinite' }}>⏳</div>
                      ) : (
                        <Info size={16} />
                      )}
                    </StatusIconWrapper>
                    <StatusContent>
                      <StatusTitle>{cancelStatus.title}</StatusTitle>
                      {cancelStatus.message && <StatusDetails>{cancelStatus.message}</StatusDetails>}
                      {cancelStatus.txHash && chainId && (
                        <StatusDetails>
                          <TxLink
                            href={getExplorerLink(chainId, cancelStatus.txHash, ExplorerDataType.TRANSACTION)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Transaction: {cancelStatus.txHash.slice(0, 10)}...{cancelStatus.txHash.slice(-8)}
                          </TxLink>
                        </StatusDetails>
                      )}
                    </StatusContent>
                    <CloseButton onClick={() => setCancelStatus(null)}>
                      <X size={16} />
                    </CloseButton>
                  </StatusMessage>
                )}
              </>
            )}
          </PendingSection>
        )}

        <MiniPortfolio account={account} />
      </PortfolioDrawerContainer>
    </AuthenticatedHeaderWrapper>
  )
}
